import { Component, Input } from "@angular/core";
import { FormControl } from "@angular/forms";
import { FormItemModel } from "services/models/form-builder/form-item.model";

@Component({
  selector: "app-form-input-textarea",
  template: `
    <div class="field-textarea" [ngbCollapse]="!isExpanded">
      <textarea
        rows="3"
        class="form-control"
        [required]="item.required"
        [placeholder]="item.placeholder ?? ''"
        [formControl]="control"
        [readonly]="readonly"
      ></textarea>
    </div>
  `,
})
export class FormInputTextareaComponent {
  @Input() item!: FormItemModel;
  @Input() control!: FormControl;
  @Input() isExpanded: boolean = false;
  @Input() readonly: boolean = false;
}
